"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickyNotificationItem = exports.StickyNotificationArea = void 0;
const Leaf = __importStar(require("leaf-ts"));
const stickyNotification_html_R_1 = require("./stickyNotification.html.R");
const stickyNotification_html_R_2 = require("./stickyNotification.theme/business/stickyNotification.html.R");
const stickyNotification_html_R_3 = require("./stickyNotification.theme/genesis/stickyNotification.html.R");
class StickyNotificationArea extends stickyNotification_html_R_1.R.StickyNotification {
    add(option) {
        const existing = this.find(option.name);
        if (existing) {
            existing.setContent(option.content);
            return existing;
        }
        const item = new StickyNotificationItem({
            area: this,
            name: option.name,
            content: option.content,
        });
        this.stickyNotificationList.push(item);
        return item;
    }
    remove(name) {
        const item = this.find(name);
        if (!item) {
            return false;
        }
        this.stickyNotificationList.removeItem(item);
        return true;
    }
    find(name) {
        return this.stickyNotificationList.toArray().find((item) => item.name === name);
    }
}
exports.StickyNotificationArea = StickyNotificationArea;
class StickyNotificationItem extends stickyNotification_html_R_1.R.StickyNotification.StickyNotificationListItem {
    constructor(option) {
        super();
        this.name = option.name;
        this.setContent(option.content);
    }
    setContent(content) {
        this.UI.content.replaceChildren();
        if (typeof content === "string") {
            this.UI.content.textContent = content;
            return;
        }
        if (content instanceof Leaf.Widget) {
            content.appendTo(this.UI.content);
            return;
        }
        this.UI.content.append(content);
    }
}
exports.StickyNotificationItem = StickyNotificationItem;
Leaf.WidgetThemeCenter.about(stickyNotification_html_R_1.R.StickyNotification).add("business", stickyNotification_html_R_2.R.StickyNotification.generator);
Leaf.WidgetThemeCenter.about(stickyNotification_html_R_1.R.StickyNotification).add("genesis", stickyNotification_html_R_3.R.StickyNotification.generator);
Leaf.WidgetThemeCenter.about(stickyNotification_html_R_1.R.StickyNotification.StickyNotificationListItem).add("business", stickyNotification_html_R_2.R.StickyNotification.StickyNotificationListItem.generator);
Leaf.WidgetThemeCenter.about(stickyNotification_html_R_1.R.StickyNotification.StickyNotificationListItem).add("genesis", stickyNotification_html_R_3.R.StickyNotification.StickyNotificationListItem.generator);
